export const paisesPt = [
  ["Afeganistão", "af", "93"],
  ["África do Sul", "za", "27"],
  ["Albânia", "al", "355"],
  ["Alemanha", "de", "49"],
  ["Andorra", "ad", "376"],
  ["Angola", "ao", "244"],
  ["Antígua e Barbuda", "ag", "1268"],
  ["Arábia Saudita", "sa", "966"],
  ["Argélia", "dz", "213"],
  ["Argentina", "ar", "54", "(..) ........", 0],
  ["Armênia", "am", "374", ".. ......"],
  ["Aruba", "aw", "297"],
  ["Austrália", "au", "61"],
  ["Áustria", "at", "43"],
  ["Azerbaijão", "az", "994"],
  ["Bahamas", "bs", "1242"],
  ["Bahrein", "bh", "973"],
  ["Bangladesh", "bd", "880"],
  ["Barbados", "bb", "1246"],
  ["Belize", "bz", "501"],
  ["Benim", "bj", "229"],
  ["Bielorrússia", "by", "375"],
  ["Bolívia", "bo", "591"],
  ["Bósnia e Herzegovina", "ba", "387"],
  ["Botsuana", "bw", "267"],
  ["Brasil", "br", "55", "(..) .....-...."],
  ["Brunei", "bn", "673"],
  ["Bulgária", "bg", "359"],
  ["Burquina Fasso", "bf", "226"],
  ["Burundi", "bi", "257"],
  ["Butão", "bt", "975"],
  ["Cabo Verde", "cv", "238"],
  ["Camarões", "cm", "237"],
  ["Camboja", "kh", "855"],
  ["Canadá", "ca", "1"],
  ["Caribe Neerlandês", "bq", "599"],
  ["Catar", "qa", "974"],
  ["Cazaquistão", "kz", "7"],
  ["Chade", "td", "235"],
  ["Chile", "cl", "56"],
  ["China", "cn", "86"],
  ["Chipre", "cy", "357"],
  ["Colômbia", "co", "57"],
  ["Comores", "km", "269"],
  ["Congo", "cg", "242"],
  ["Congo (RDC)", "cd", "243"],
  ["Coreia do Norte", "kp", "850"],
  ["Coreia do Sul", "kr", "82"],
  ["Costa do Marfim", "ci", "225"],
  ["Costa Rica", "cr", "506"],
  ["Croácia", "hr", "385"],
  ["Cuba", "cu", "53"],
  ["Curaçao", "cw", "599"],
  ["Dinamarca", "dk", "45"],
  ["Djibuti", "dj", "253"],
  ["Dominica", "dm", "1767"],
  ["Egito", "eg", "20"],
  ["El Salvador", "sv", "503"],
  ["Emirados Árabes Unidos", "ae", "971"],
  ["Equador", "ec", "593"],
  ["Eritreia", "er", "291"],
  ["Eslováquia", "sk", "421"],
  ["Eslovênia", "si", "386"],
  ["Espanha", "es", "34"],
  ["Estados Unidos", "us", "1"],
  ["Estônia", "ee", "372"],
  ["Etiópia", "et", "251"],
  ["Fiji", "fj", "679"],
  ["Filipinas", "ph", "63"],
  ["Finlândia", "fi", "358"],
  ["França", "fr", "33"],
  ["Gabão", "ga", "241"],
  ["Gâmbia", "gm", "220"],
  ["Gana", "gh", "233"],
  ["Geórgia", "ge", "995"],
  ["Granada", "gd", "1473"],
  ["Grécia", "gr", "30"],
  ["Groenlândia", "gl", "299"],
  ["Guadalupe", "gp", "590"],
  ["Guam", "gu", "1671"],
  ["Guatemala", "gt", "502"],
  ["Guiana", "gy", "592"],
  ["Guiana Francesa", "gf", "594"],
  ["Guiné", "gn", "224"],
  ["Guiné Equatorial", "gq", "240"],
  ["Guiné-Bissau", "gw", "245"],
  ["Haiti", "ht", "509"],
  ["Honduras", "hn", "504"],
  ["Hong Kong", "hk", "852"],
  ["Hungria", "hu", "36"],
  ["Iêmen", "ye", "967"],
  ["Ilhas Cayman", "ky", "1"],
  ["Ilhas Faroé", "fo", "298"],
  ["Ilhas Marshall", "mh", "692"],
  ["Ilhas Salomão", "sb", "677"],
  ["Índia", "in", "91"],
  ["Indonésia", "id", "62"],
  ["Irã", "ir", "98"],
  ["Iraque", "iq", "964"],
  ["Irlanda", "ie", "353"],
  ["Islândia", "is", "354"],
  ["Israel", "il", "972"],
  ["Itália", "it", "39"],
  ["Jamaica", "jm", "1876"],
  ["Japão", "jp", "81"],
  ["Jordânia", "jo", "962"],
  ["Kiribati", "ki", "686"],
  ["Kosovo", "xk", "383"],
  ["Kuwait", "kw", "965"],
  ["Laos", "la", "856"],
  ["Lesoto", "ls", "266"],
  ["Letônia", "lv", "371"],
  ["Líbano", "lb", "961"],
  ["Libéria", "lr", "231"],
  ["Líbia", "ly", "218"],
  ["Liechtenstein", "li", "423"],
  ["Lituânia", "lt", "370"],
  ["Luxemburgo", "lu", "352"],
  ["Macau", "mo", "853"],
  ["Macedônia do Norte", "mk", "389"],
  ["Madagascar", "mg", "261"],
  ["Malawi", "mw", "265"],
  ["Malásia", "my", "60"],
  ["Maldivas", "mv", "960"],
  ["Mali", "ml", "223"],
  ["Malta", "mt", "356"],
  ["Marrocos", "ma", "212"],
  ["Martinica", "mq", "596"],
  ["Mauritânia", "mr", "222"],
  ["Maurício", "mu", "230"],
  ["Mayotte", "yt", "262"],
  ["México", "mx", "52"],
  ["Micronésia", "fm", "691"],
  ["Moldávia", "md", "373"],
  ["Mônaco", "mc", "377"],
  ["Mongólia", "mn", "976"],
  ["Montenegro", "me", "382"],
  ["Moçambique", "mz", "258"],
  ["Mianmar (Birmânia)", "mm", "95"],
  ["Namíbia", "na", "264"],
  ["Nauru", "nr", "674"],
  ["Nepal", "np", "977"],
  ["Nicarágua", "ni", "505"],
  ["Níger", "ne", "227"],
  ["Nigéria", "ng", "234"],
  ["Noruega", "no", "47"],
  ["Nova Caledônia", "nc", "687"],
  ["Nova Zelândia", "nz", "64"],
  ["Omã", "om", "968"],
  ["Países Baixos", "nl", "31"],
  ["Palau", "pw", "680"],
  ["Palestina", "ps", "970"],
  ["Panamá", "pa", "507"],
  ["Papua-Nova Guiné", "pg", "675"],
  ["Paquistão", "pk", "92"],
  ["Paraguai", "py", "595"],
  ["Peru", "pe", "51"],
  ["Polinésia Francesa", "pf", "689"],
  ["Polônia", "pl", "48"],
  ["Portugal", "pt", "351"],
  ["Porto Rico", "pr", "1"],
  ["Quênia", "ke", "254"],
  ["Quirguistão", "kg", "996"],
  ["Reino Unido", "gb", "44"],
  ["Reunião", "re", "262"],
  ["Romênia", "ro", "40"],
  ["Ruanda", "rw", "250"],
  ["Rússia", "ru", "7"],
  ["Samoa", "ws", "685"],
  ["San Marino", "sm", "378"],
  ["Santa Lúcia", "lc", "1758"],
  ["São Cristóvão e Névis", "kn", "1869"],
  ["São Tomé e Príncipe", "st", "239"],
  ["São Vicente e Granadinas", "vc", "1784"],
  ["Seicheles", "sc", "248"],
  ["Senegal", "sn", "221"],
  ["Serra Leoa", "sl", "232"],
  ["Sérvia", "rs", "381"],
  ["Singapura", "sg", "65"],
  ["Síria", "sy", "963"],
  ["Somália", "so", "252"],
  ["Sri Lanka", "lk", "94"],
  ["Sudão", "sd", "249"],
  ["Sudão do Sul", "ss", "211"],
  ["Suazilândia (Eswatini)", "sz", "268"],
  ["Suécia", "se", "46"],
  ["Suíça", "ch", "41"],
  ["Suriname", "sr", "597"],
  ["Tailândia", "th", "66"],
  ["Taiwan", "tw", "886"],
  ["Tajiquistão", "tj", "992"],
  ["Tanzânia", "tz", "255"],
  ["Território Britânico do Oceano Índico", "io", "246"],
  ["Timor-Leste", "tl", "670"],
  ["Togo", "tg", "228"],
  ["Tonga", "to", "676"],
  ["Trinidad e Tobago", "tt", "1868"],
  ["Tunísia", "tn", "216"],
  ["Turcomenistão", "tm", "993"],
  ["Turquia", "tr", "90"],
  ["Tuvalu", "tv", "688"],
  ["Ucrânia", "ua", "380"],
  ["Uganda", "ug", "256"],
  ["Uruguai", "uy", "598"],
  ["Uzbequistão", "uz", "998"],
  ["Vanuatu", "vu", "678"],
  ["Vaticano", "va", "39"],
  ["Venezuela", "ve", "58"],
  ["Vietnã", "vn", "84"],
  ["Wallis e Futuna", "wf", "681"],
  ["Zâmbia", "zm", "260"],
  ["Zimbábue", "zw", "263"],
];
